import { DateTime } from 'luxon';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useBillingStore } from '@/stores';

export function useConnectorTrialEndDate() {
  const { isOnFreeTrial, freeTrialEndDate, isConnectorTier } =
    storeToRefs(useBillingStore());

  const daysLeft = computed<number>(() => {
    if (!isOnFreeTrial.value || !freeTrialEndDate.value) return 0;
    const today = DateTime.now();
    const endDate = DateTime.fromISO(freeTrialEndDate.value);
    const days = Math.ceil(endDate.diff(today, 'days').days);
    if (days <= 0) return 0;
    return days;
  });

  const daysLeftText = computed<string>(() => {
    if (daysLeft.value === 1) return `${daysLeft.value} day`;
    return `${daysLeft.value} days`;
  });

  const isTrialOver = computed(() => isOnFreeTrial.value && !daysLeft.value);

  const isActivelyInTrial = computed(
    () => isOnFreeTrial.value && !isTrialOver.value,
  );

  const isTrueConnector = computed(
    () => isConnectorTier.value && !isOnFreeTrial.value,
  );

  return {
    daysLeft,
    daysLeftText,
    freeTrialEndDate,
    isActivelyInTrial,
    isTrialOver,
    isTrueConnector,
  };
}
